import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ChatTongole from './components/Chat/ChatTongole';
import DownloadNotice from './common/downloadNotice';

// Set data-origin on <html> for origin-scoped styling
const originForAttr = window.location.origin
  .replace(/^https?:\/\/(www\.)?/, '')
  .replace(/(\.com|\.live|\.net|\.world)$/i, '');
document.documentElement.setAttribute('data-origin', originForAttr);

ReactDOM.render(
  <BrowserRouter>
  <DownloadNotice/>
  <ChatTongole/>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);